<script lang="ts" setup>
const route = useRoute()

const { language } = route.params

useSeo({
  title: `Listen to the Best ${language}-Speaking Radio Stations Online`,
  description: `Discover and enjoy top-rated ${language}-speaking radio stations from around the world. Tune in for music, news, and entertainment tailored for ${language} speakers. Start listening now!`,
})
</script>

<template>
  <div class="md:space-y-12 space-y-6">
    <PageTitle :route="{ name: 'radio' }">
      Radio Stations in <span>{{ language }}</span>
    </PageTitle>

    <SearchInput />

    <StationCatalog :language="language as string" :limit="20" :query="route.query?.query as string" />
  </div>
</template>

<style scoped></style>
